import React from "react";
import Select from "react-select";
import ArrowLeft from "../../assets/images/arrowLeft.svg";
import ArrowRight from "../../assets/images/arrowRight.svg";
import styles from "./tablePagination.module.scss"
import {getSelectStyles} from "../../utils";

const TablePagination = ({items, onItemsPerPageChange, itemsPerPage, onPageChange, currentPage, total, showTotal = true}) => {
  const itemsPerPageOptions = [
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 20, label: '20' },
    { value: 25, label: '25' },
    { value: 30, label: '30' },
  ]

  return (
    <div key={`${JSON.stringify(items)}-${currentPage}`} className={styles.paginationContainer}>
      <div className={styles.pageCountContainer}>
        # of results
        <Select
          defaultValue={{
            value: itemsPerPage,
            label: itemsPerPage.toString()
          }}
          onChange={async ({value}) => {
            await onItemsPerPageChange(value)
          }}
          options={itemsPerPageOptions}
          styles={getSelectStyles()}
        />
      </div>
      <div className={styles.pageNavigatorContainer}>
        Page
        <div className={styles.navigatorComponent}>
          <div className={currentPage === 1 ? styles.iconDisabled : styles.icon} onClick={() => {
            if (currentPage > 1) onPageChange({gotoPage: currentPage - 1});
          }}>
            <img src={ArrowLeft} alt="Previous Page"/>
          </div>
          {
          showTotal ? 
            <p className={styles.currPage}>{currentPage} of {Math.ceil(total/itemsPerPage)}</p> :
            <p className={styles.currPage}>{currentPage}</p>
          }
          <div
            className={currentPage === Math.ceil(total/itemsPerPage) ? styles.iconDisabled : styles.icon} onClick={() => {
              if (currentPage === Math.ceil(total/itemsPerPage)) return;
              onPageChange({gotoPage: currentPage + 1})
          }}
          >
            <img src={ArrowRight} alt="Next Page"/>
          </div>

          
        </div>
      </div>
    </div>
  )
}

export default TablePagination;

